import { merge } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import template from '@/components/services/settings/template'

export default function(options) {
  const mergedOptions = merge({}, { serviceName: Services.settingsSite }, options)

  return {
    render(h) {
      return h(template(mergedOptions))
    }
  }
}
